module.exports = __webpack_public_path__ + "staticcomp/img/top.bd4b75b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1/7/top.jpg
// module id = /ioZ
// module chunks = 39